import * as ArrayUtils from '../../common/util/array';
import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingCombos': false,
  'loadingTasks': false,
  'loadingCandidateTasks': false,
  'adding': false,
  'submitting': false,
  'deleting': false,
  'searchedTasks': false,
  'combos': [],
  'tasks': [],
  'candidateTasks': [],
  'selectedCombo': '',
  'selectedTask': '',
};

const removeSelectedOption = (candidateTasks, selectedTask) => {
  const selectedCode = `${selectedTask.serviceCode1}${selectedTask.serviceCode2}${selectedTask.serviceCode3}`;
  return candidateTasks.filter((item) => {
    return `${item.serviceCode1}${item.serviceCode2}${item.serviceCode3}` !== selectedCode;
  });
};

export const parseCombos = (combos = []) => {
  return combos.reduce((options, combo) => {
    if (options[combo.code]) {
      options[combo.code] = {
        ...options[combo.code],
        'models': [...options[combo.code].models, {'model': combo.carModel, 'masterCode': combo.masterCode}],
      };
    } else {
      options[combo.code] = {
        'code': combo.code,
        'description': combo.description,
        'models': [{'model': combo.carModel, 'masterCode': combo.masterCode}],
      };
    }
    return options;
  }, {});
};

export const comboTasks = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_COMBO_TASKS_PAGE]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
    [ActionTypes.SELECT_COMBO]: (state, action) => ({
      ...state,
      'selectedCombo': state.combos[action.payload],
      'searchedTasks': false,
      'tasks': [],
      'candidateTasks': [],
    }),
    [ActionTypes.SELECT_COMBO_TASK]: (state, action) => ({
      ...state,
      'selectedTask': {...state.candidateTasks[action.payload]},
    }),
    [ActionTypes.ADD_COMBO_TASK]: (state, action) => ({
      ...state,
      'adding': true,
      'tasks': ArrayUtils.addItem(state.tasks, {}),
    }),
    [ActionTypes.REMOVE_COMBO_TASK]: (state, action) => ({
      ...state,
      'adding': false,
      'tasks': ArrayUtils.removeItem(state.tasks, action.payload),
    }),
    [ActionTypes.GETTING_ACCESSORIES_COMBOS]: (state, action) => ({
      ...state,
      'loadingCombos': true,
    }),
    [ActionTypes.GOTTEN_ACCESSORIES_COMBOS]: (state, action) => ({
      ...state,
      'loadingCombos': false,
      'combos': parseCombos(action.response.data),
    }),
    [ActionTypes.GOTTEN_ACCESSORIES_COMBOS_FAILED]: (state, action) => ({
      ...state,
      'loadingCombos': false,
    }),
    [ActionTypes.GETTING_COMBO_TASKS]: (state, action) => ({
      ...state,
      'loadingTasks': true,
    }),
    [ActionTypes.GOTTEN_COMBO_TASKS]: (state, action) => ({
      ...state,
      'loadingTasks': false,
      'adding': false,
      'selectedTask': '',
      'tasks': action.response.data,
    }),
    [ActionTypes.GOTTEN_COMBO_TASKS_FAILED]: (state, action) => ({
      ...state,
      'loadingTasks': false,
      'tasks': [],
    }),
    [ActionTypes.GETTING_COMBO_CANDIDATE_TASKS]: (state, action) => ({
      ...state,
      'loadingCandidateTasks': true,
    }),
    [ActionTypes.GOTTEN_COMBO_CANDIDATE_TASKS]: (state, action) => ({
      ...state,
      'loadingCandidateTasks': false,
      'searchedTasks': true,
      'candidateTasks': action.response.data,
    }),
    [ActionTypes.GOTTEN_COMBO_CANDIDATE_TASKS_FAILED]: (state, action) => ({
      ...state,
      'loadingCandidateTasks': false,
      'candidateTasks': [],
    }),
    [ActionTypes.ASSIGNING_COMBO_TASK]: (state, action) => ({
      ...state,
      'submitting': true,
    }),
    [ActionTypes.ASSIGNED_COMBO_TASK]: (state, action) => ({
      ...state,
      'submitting': false,
      'adding': false,
      'tasks': ArrayUtils.replaceItem(state.tasks, action.payload, action.response.data),
      'candidateTasks': removeSelectedOption(state.candidateTasks, action.response.data),
    }),
    [ActionTypes.ASSIGNED_COMBO_TASK_FAILED]: (state, action) => ({
      ...state,
      'submitting': false,
    }),
    [ActionTypes.DELETING_COMBO_TASK]: (state, action) => ({
      ...state,
      'deleting': true,
    }),
    [ActionTypes.DELETED_COMBO_TASK]: (state, action) => ({
      ...state,
      'deleting': false,
      'tasks': ArrayUtils.removeItem(state.tasks, action.payload.index),
      'candidateTasks': ArrayUtils.addItem(state.candidateTasks, action.payload.taskData),
    }),
    [ActionTypes.DELETED_COMBO_TASK_FAILED]: (state, action) => ({
      ...state,
      'deleting': false,
    }),
  })(state, action);
};
